import { motion, useReducedMotion } from "framer-motion";
import { HACKATHON } from "@/data/agenticHackathon";
import { springTransition } from "@/lib/motionVariants";

/**
 * Venue chip — same visual language as the macOS-style calendar (black + white capsule).
 */
export default function HackathonVenueCapsule({ className = "" }) {
    const reduceMotion = useReducedMotion();

    return (
        <motion.div
            data-testid="hackathon-venue-capsule"
            initial={reduceMotion ? false : { opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, ...springTransition }}
            className={`inline-flex max-w-full overflow-hidden rounded-[10px] sm:rounded-xl ring-1 ring-white/15 shadow-[0_8px_24px_-8px_rgba(0,0,0,0.35)] ${className}`}
        >
            <span className="inline-flex items-center shrink-0 bg-zinc-950 px-3 py-2 sm:px-3.5 sm:py-2.5 border-r border-white/10">
                <span className="font-display text-[10px] sm:text-xs font-semibold uppercase tracking-[0.14em] text-white whitespace-nowrap">
                    {HACKATHON.venueLabel}
                </span>
            </span>
            <span className="inline-flex items-center min-w-0 bg-white px-3 py-2 sm:px-4 sm:py-2.5">
                <span className="font-display text-sm sm:text-base font-semibold text-zinc-900 tracking-tight truncate">
                    {HACKATHON.venuePlace}
                </span>
            </span>
        </motion.div>
    );
}
